
export function redirect(url) {
  window.location.assign(decodeURIComponent(url));
}
